import React from 'react';
import { useSelector } from 'src/client/redux';
import { STATUS_OPTED_IN, TYPE_TOP_10 } from 'src/shared/constants/newsletter';
import { StyledIcon } from 'src/client/components/ui/StyledIcon';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import NewsletterForm, { newsletterForm } from 'src/client/containers/NewsletterForm/NewsletterForm';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import styled from 'styled-components/macro';
import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { MenuTitle } from './FooterCategoryMenu';

type Props = {
  setInfoModal: React.Dispatch<React.SetStateAction<boolean>>;
  infoModal: boolean;
};

export const FooterBarNewsletter = (props: Props) => {
  const { status, submitted } = useSelector((state) => state.newsletter);
  const { footer } = useSelector((state) => state.app.config);
  const showSfwSite = useShowSfwSite();
  const newsletterStatus = status !== STATUS_OPTED_IN || submitted;

  if (showSfwSite || !newsletterStatus || !footer.hasWeeklyTopModels) {
    return null;
  }

  return (
    <NewsletterWrapper>
      <FreeWeekly>
        <Highlight>Free</Highlight> Weekly Top Ten Models
      </FreeWeekly>
      <DontMiss>Don&#39;t Miss Out</DontMiss>
      <NewsletterText>
        <strong>Receive</strong> the <strong>Weekly Top 10 Models</strong> directly to your <strong>inbox</strong>.
        You'll also get <strong>exclusive deals</strong> only available through our newsletters.
        <br />
        <MoreInfoButton onClick={() => props.setInfoModal(!props.infoModal)}>
          <StyledIcon $spaceRight icon={faInfoCircle} />
          <span>More Information</span>
        </MoreInfoButton>
      </NewsletterText>
      <NewsletterForm
        newsletterType={TYPE_TOP_10}
        submitBtnClassName="btn btn-primary subscribe-btn"
        form={newsletterForm}
      />
    </NewsletterWrapper>
  );
};

const NewsletterWrapper = styled.div`
  border-top: 1px solid ${(props) => props.theme.footerBarPrimary4};
  list-style: none;
  display: inline-flex;
  width: 100%;
  flex-basis: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: 22px;
  padding-bottom: 35px;

  @media ${TABLET_PORTRAIT} {
    align-items: flex-start;
    border-top: 0;
  }

  @media ${DESKTOP} {
    flex-basis: 33%;
    max-width: 33%;
    padding: 0;
  }

  .subscribe-btn {
    position: relative;
    max-width: 90%;
    left: 5%;

    @media ${TABLET_PORTRAIT} {
      max-width: 100%;
      left: 0;
    }
  }
`;

const Highlight = styled.strong`
  color: ${(props) => props.theme.footerBarPrimary6};
`;

const NewsletterText = styled.span`
  font-size: 0.85rem;
  margin-bottom: 15px;
  line-height: 18px;
  text-align: center;

  @media ${TABLET_PORTRAIT} {
    font-size: 0.9rem;
    line-height: 24px;
    text-align: left;
    max-width: 90%;
  }

  .highlight {
    padding-left: 4px;
    color: ${(props) => props.theme.footerBarPrimary3};
  }

  strong {
    color: ${(props) => props.theme.footerBarPrimary3};
  }
`;

const MoreInfoButton = styled.div`
  cursor: pointer;
  transition: color 300ms;

  &:hover {
    color: ${(props) => props.theme.footerBarPrimary3};
  }
`;

const NewsletterTitle = styled(MenuTitle)`
  text-align: center;
  text-transform: uppercase;
  font-size: 1.4rem;
  color: ${(props) => props.theme.footerBarPrimary3};

  @media ${TABLET_PORTRAIT} {
    width: 100%;
    font-size: 1rem;
    text-align: left;
  }
`;

const DontMiss = styled(NewsletterTitle)`
  @media ${TABLET_PORTRAIT} {
    display: none;
  }
`;

const FreeWeekly = styled(NewsletterTitle)`
  display: none;

  @media ${TABLET_PORTRAIT} {
    display: block;
  }
`;
